import React from 'react';
import { get } from 'lodash';

import {
  FieldArray,
  useFormikContext,
  ErrorMessage,
} from 'formik';

import ListResource from '../lists/ListResource.jsx';
import { isPermitted } from '../layout/Nav.jsx';

const FieldList = ({
  name,
  list: {
    sort = { createdAt: 1 },
    actions = {
      create: false,
      remove: false,
    },
    onRowClick = () => {},
    helperText = '',
    ...list
  } = {},
  children,
  segment = '',
  disabled = false,
}) => {
  const { values, status } = useFormikContext();
  const arr = get(values, name) || [];
  const isDisabled = status?.disabled || disabled;

  return (
    <>
      <FieldArray name={name}>
        {(helper) => (
          <>
            <ErrorMessage name={name}>
              {(msg) => (
                  <div className="text-danger text-capitalize font-weight-bold">
                    {msg}
                  </div>
              )}
            </ErrorMessage>
            {helperText && (
              <div className="row">
                <div className="col">{helperText}</div>
              </div>
            )}
            <div className="row">
              <div className="col">
                {isPermitted(segment) && (
                  <ListResource
                    {...{
                      sort,
                      actions,
                      onRowClick: (row) => {
                        if (isDisabled) return null;
                        return onRowClick({
                          row,
                          helper,
                          arr,
                          values,
                        });
                      },
                      ...list,
                    }}
                  />
                )}
              </div>
              <div className="col">
                {typeof children === 'function'
                  ? children({
                    helper,
                    arr,
                    values,
                    formStatus: status,
                  })
                  : children}
              </div>
            </div>
          </>
        )}
      </FieldArray>
    </>
  );
};

export default FieldList;
